/**
 * Firebase initialization — spec §3.5 Technology Stack
 * Single source of truth for all Firebase service instances.
 */

import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyD8MUyVY8nyuJ0gJWCKNdL-d_tG02S1uhw",
  authDomain: "pullpress-2250b.firebaseapp.com",
  projectId: "pullpress-2250b",
  storageBucket: "pullpress-2250b.firebasestorage.app",
  messagingSenderId: "934249550140",
  appId: "1:934249550140:web:d6e62eed5e1f29e0bb8e39",
  measurementId: "G-0H8LSGMKT5",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Service instances — imported throughout the application
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Analytics (client-side only, lazy init)
let analytics: ReturnType<typeof getAnalytics> | null = null;
export function getAnalyticsInstance() {
  if (!analytics && typeof window !== "undefined") {
    analytics = getAnalytics(app);
  }
  return analytics;
}

// Connect to emulators only when explicitly requested.
// The local app should still open against the configured Firebase project when
// the emulator suite is not running.
if (import.meta.env.DEV && import.meta.env.VITE_USE_FIREBASE_EMULATORS === "true") {
  try {
    connectAuthEmulator(auth, "http://localhost:9099", { disableWarnings: true });
    connectFirestoreEmulator(db, "localhost", 8080);
    connectStorageEmulator(storage, "localhost", 9199);
    connectFunctionsEmulator(functions, "localhost", 5001);
    console.log("[StoryForge] Connected to Firebase emulators");
  } catch {
    // Emulators may not be running — that's OK in dev
    console.warn("[StoryForge] Firebase emulators not available");
  }
}
